/**
 * Company-spezifische API-Funktionen
 * Projektgesellschaft und Gesellschafter
 */
import { api } from './client';
import {
  CompanyWithShareholders,
  CompanyUpdate,
  ShareholderCreate,
  ShareholderUpdate,
} from '../../types';

export const companiesApi = {
  // Company (Gesellschaft)

  async getCompany(projectId: string): Promise<CompanyWithShareholders> {
    return api.get(`/projects/${projectId}/company`);
  },

  async updateCompany(projectId: string, data: CompanyUpdate): Promise<CompanyWithShareholders> {
    return api.put(`/projects/${projectId}/company`, data);
  },

  // Shareholders (Gesellschafter)

  async createShareholder(projectId: string, data: ShareholderCreate): Promise<CompanyWithShareholders> {
    return api.post(`/projects/${projectId}/company/shareholders`, data);
  },

  async updateShareholder(
    projectId: string,
    shareholderId: string,
    data: ShareholderUpdate,
  ): Promise<CompanyWithShareholders> {
    return api.put(`/projects/${projectId}/company/shareholders/${shareholderId}`, data);
  },

  async deleteShareholder(projectId: string, shareholderId: string): Promise<CompanyWithShareholders> {
    return api.delete(`/projects/${projectId}/company/shareholders/${shareholderId}`);
  },

  async getKommanditistNameOptions(): Promise<string[]> {
    return api.get('/companies/kommanditist-name-options');
  },
};
